// extracted by mini-css-extract-plugin
module.exports = {"maindiv":"course-create-exam_maindiv__1v750","miniModal":"course-create-exam_miniModal__3pNAb","stepsBtn":"course-create-exam_stepsBtn__ztrZT"};